import { Grid } from "@mui/material";
import MxTypography from "../../MxTypography";

interface MxFormSubTitleProps {
  label: string;
  isRequired?: boolean;
}
const MxFormSubTitle = (props: MxFormSubTitleProps) => {
  return (
    <Grid item>
      <MxTypography
        variant="subtitle2"
        color="primary.main"
        className={props.isRequired ? "MXrequired" : ""}
      >
        {props.label}
      </MxTypography>
    </Grid>
  );
};

export default MxFormSubTitle;
